import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
    return (
        <>
            <SEO title="Page non trouvée" description="La page demandée n'existe pas." />
            <section className="max-w-[860px] mx-auto px-6 lg:px-10 py-32 text-center">
                <div className="divider-tag justify-center mb-6">404</div>
                <h1 className="font-display text-5xl text-white mb-5">Page non trouvée</h1>
                <p className="text-white/65 mb-8">Cette page n'existe pas ou n'est plus disponible.</p>
                <Link to="/" className="btn-primary inline-flex">Retour à l'accueil</Link>
            </section>
        </>
    );
}
